"use strict";

var _Symbol = require("babel-runtime/core-js/symbol")["default"];

exports["default"] = function (obj) {
  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/helpers/typeof.js
// module id = 1516
// module chunks = 243